import { PayloadStates } from '@lore/utils';
import useProjectInvitationsResponded from './useProjectInvitationsResponded';
import useEventInvitationsResponded from './useEventInvitationsResponded';

export default function useInvitationsResponded(network, timestamp) {
  const projectEvaluations = useProjectInvitationsResponded(network, timestamp);
  const eventEvaluations = useEventInvitationsResponded(network, timestamp);

  if (
    projectEvaluations.state === PayloadStates.FETCHING ||
    eventEvaluations.state === PayloadStates.FETCHING
  ) {
    return {
      state: PayloadStates.FETCHING,
      data: [],
      meta: {}
    };
  }

  return {
    state: PayloadStates.RESOLVED,
    meta: {
      totalCount: projectEvaluations.meta.totalCount + eventEvaluations.meta.totalCount
    }
  };
}
